module.exports = __webpack_public_path__ + "img/constant-house.e777c730.jpg";